import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import FontFamilyMaterialMUI from '../../components/FontFamilyTextList';

import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';

const MapsAdvancedIntroductionField = props => {
  const {
    listComponentsAdvanced,
    textSettings,
    setTextSettings,
    setListComponentsAdvanced,
    mapTypes,
    setMapTypes
  } = props;
  const namesArray = mapTypes.map(item => item.name);
  const [mapSelectedName, setMapSelectedName] = React.useState(namesArray);
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.IntroductionMapComponent.name
  );
  const [settings, setSettings] = React.useState(textSettings);

  const [openModal, setOpenModal] = React.useState(false);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.IntroductionMapComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(
    listComponentsAdvanced.IntroductionMapComponent.iconSvg
  );
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.IntroductionMapComponent.libraryIcon
  );

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        IntroductionMapComponent: {
          name: listComponentsAdvanced.IntroductionMapComponent.name,
          show: listComponentsAdvanced.IntroductionMapComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        IntroductionMapComponent: {
          name: listComponentsAdvanced.IntroductionMapComponent.name,
          show: listComponentsAdvanced.IntroductionMapComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  const allTypeFonts = FontFamilyMaterialMUI;
  const allMapTypes = [
    { value: 'map', name: 'Mapa' },
    { value: 'map3D', name: 'Mapa 3D' },
    // { value: 'mapDeckGL', name: 'Mapa Deck GL' }, // comment deck
    { value: 'mapSync', name: 'Mapa Sincronizado' }
  ];

  const handleChangeText = (event, text) => {
    const { value } = event.target;
    let saveTitle = settings.title;
    let saveDescription = settings.description;
    let saveDescriptionHeight = settings.descriptionHeight;
    let saveFont = settings.font;
    let saveLogo = settings.logo;
    let saveShowTitle = settings.showTitle;
    let saveShowImagen = settings.showImagen;
    const saveLogoHeight = settings.logoHeight;

    if (text === 'title') {
      saveTitle = parseInt(value, 10);
      setSettings({ ...settings, title: parseInt(value, 10) });
    }
    if (text === 'description') {
      saveDescription = parseInt(value, 10);
      setSettings({ ...settings, description: parseInt(value, 10) });
    }
    if (text === 'descriptionHeight') {
      if (isEmpty(value)) {
        saveDescriptionHeight = '';
        setSettings({ ...settings, descriptionHeight: '' });
      } else {
        saveDescriptionHeight = parseInt(value, 10);
        setSettings({ ...settings, descriptionHeight: parseInt(value, 10) });
      }
    }
    if (text === 'font') {
      saveFont = value;
      setSettings({ ...settings, font: value });
    }
    if (text === 'logo') {
      saveLogo = value;
      setSettings({ ...settings, logo: value });
    }
    if (text === 'showTitle') {
      saveShowTitle = !settings.showTitle;
      setSettings({ ...settings, showTitle: saveShowTitle });
    }
    if (text === 'showImagen') {
      saveShowImagen = !settings.showImagen;
      setSettings({ ...settings, showImagen: saveShowImagen });
    }
    if (text === 'logoHeight') {
      saveShowImagen = !settings.logoHeight;
      setSettings({ ...settings, logoHeight: saveLogoHeight });
    }

    setTextSettings({
      showTitle: saveShowTitle,
      showImagen: saveShowImagen,
      description: saveDescription,
      descriptionHeight: saveDescriptionHeight,
      font: saveFont,
      logo: saveLogo,
      title: saveTitle,
      logoHeight: saveLogoHeight
    });
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  const handleChange = value => {
    const selectedValues = typeof value === 'string' ? value.split(',') : value;
    const selectedObjects = allMapTypes.filter(item => selectedValues.includes(item.name));
    const selectedNames = selectedObjects.map(item => item.name);
    setMapTypes(selectedObjects);
    setMapSelectedName(selectedNames);
  };

  return (
    <Box display="flex" width="100%" gab={1} justifyContent="space-around">
      <Box display="column" width="40%" gab={1}>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <CoPresentIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() => {
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                IntroductionMapComponent: {
                  name: nameComponent,
                  show: listComponentsAdvanced.IntroductionMapComponent.show
                }
              });
            }}
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={handleIconSelected}
            selectedIcon={listComponentsAdvanced.IntroductionMapComponent.iconFontawesome}
            startLibrary={listComponentsAdvanced.IntroductionMapComponent.libraryIcon}
            svg={listComponentsAdvanced.IntroductionMapComponent.iconSvg}
            startCategorySvg={listComponentsAdvanced.IntroductionMapComponent.cetegorySvg}
          />
        </Box>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-multiple-chip-label">Tipos de mapas</InputLabel>
          <Select
            labelId="demo-multiple-chip-label"
            label="Tipos de mapas"
            id="demo-multiple-chip"
            size="small"
            multiple
            sx={{ minWidth: 120 }}
            value={mapSelectedName}
            onChange={e => handleChange(e.target.value)}
            input={<OutlinedInput id="select-multiple-chip" label="Tipos de mapa" />}
            renderValue={selected => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map(value => (
                  <Chip key={value} label={value} />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {allMapTypes.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Typography sx={{ mb: 2 }}>Font options</Typography>
        <TextField
          id="outlined-required"
          label="Title font size"
          size="small"
          value={settings.title}
          onChange={e => handleChangeText(e, 'title')}
          sx={{ mb: 2 }}
        />
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Description font size"
            size="small"
            value={settings.description}
            onChange={e => handleChangeText(e, 'description')}
          />
          <TextField
            id="outlined-required"
            label="Height of description"
            size="small"
            value={settings.descriptionHeight}
            onChange={e => handleChangeText(e, 'descriptionHeight')}
            mb={2}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>
            }}
          />
        </Box>
        <FormControl fullWidth>
          <InputLabel id="demo-select-label">Font</InputLabel>
          <Select
            labelId="demo-select-label"
            sx={{ mb: 2 }}
            id="demo-select"
            label="Font"
            size="small"
            value={settings.font}
            onChange={e => handleChangeText(e, 'font')}
          >
            {Object.entries(allTypeFonts).map(([key, value]) => (
              <MenuItem key={key} value={value}>
                {value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Logo"
            size="small"
            value={settings.logo}
            onChange={e => handleChangeText(e, 'logo')}
            sx={{ mb: 2 }}
            fullWidth
          />
          <TextField
            id="outlined-required"
            label="Height of logo"
            size="small"
            value={settings.logoHeight}
            onChange={e => handleChangeText(e, 'logoHeight')}
            mb={2}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>
            }}
          />
        </Box>
        <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
          <Checkbox
            checked={settings.showTitle ? settings.showTitle : false}
            onChange={e => handleChangeText(e, 'showTitle')}
            sx={{
              color: '#2A3F90',
              '&.Mui-checked': {
                color: '#2A3F90'
              }
            }}
            value="showTitle"
          />
          Show title
        </Box>
        <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
          <Checkbox
            checked={settings.showImagen ? settings.showImagen : false}
            onChange={e => handleChangeText(e, 'showImagen')}
            sx={{
              color: '#2A3F90',
              '&.Mui-checked': {
                color: '#2A3F90'
              }
            }}
            value="showImagen"
          />
          Show image
        </Box>
      </Box>
      <Box display="column" width="40%" gab={1} />
    </Box>
  );
};
export default MapsAdvancedIntroductionField;
MapsAdvancedIntroductionField.defaultProps = {
  mapTypes: [{ value: 'map', name: 'Mapa' }],
  textSettings: {
    title: 24,
    description: 18,
    font: 'Arial',
    showTitle: true,
    showImagen: true,
    descriptionHeight: 100
  },
  setTextSettings: () => {},
  setMapTypes: () => {},
  setListComponentsAdvanced: () => {}
};
MapsAdvancedIntroductionField.propTypes = {
  textSettings: PropTypes.object,
  setTextSettings: PropTypes.func,
  mapTypes: PropTypes.array,
  setMapTypes: PropTypes.func,
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func
};
